export const BUS_ACCESS_TOKEN = "sg-connect.access-token";
export const BUS_USER_CONNECTION = "sg-connect.user-connection";
